import { t } from '../../utils/i18n';
import { navigate } from './movePages';
import { SCREEN } from '../../utils/constants';
import { removeAllSelectedLocation } from '../actions/locationActions';
import { removeAllSelectProvider } from '../actions/providerActions';
import { removeAllProcedures } from '../actions/procedureActions';
import { removeAllSelectedInterest } from '../actions/interestActions';
import { removeFullName } from '../actions/fullNameActions';
import { removeEmail } from '../actions/emailActions';
import { removePhone } from '../actions/phoneActions';
import { estimateInfo, phoneToCall, providers, providerId, appUrl, financing, hidePricing } from '../../utils/variables';
import { openInstantQuotes } from './movePages';
import { loadConsultDetail } from '../../views/pages/consultSummary';
import { handelConsultSummaryBtn } from './consultListeners';

export function instantQuoteSummaryListeners() {
  const refreshElement = document.querySelector('.instant_quote_summary__container .refresh');
  if (refreshElement) {
    refreshElement.onclick = () => {
      clearAllInput();
      openInstantQuotes(SCREEN.INSTANT_QUOTE);
    };
  }
  if(!financing || !estimateInfo?.monthly_payment) {
    document.querySelector('.js-quote-total.js-quote-total-title').style.display = 'block';
    document.querySelector('.instant_quote_summary__container .switch-button').style.display = 'none';
  } else {
    document.querySelector('.js-quote-total.js-quote-total-title').style.display = 'none';
    document.querySelector('.instant_quote_summary__container .switch-button').style.display = 'inline-block';
  }
  addColorButtonSwitch();
  document.querySelector('.instant_quote_summary__container .phone').onclick = () =>
    (window.parent.location.href = `tel:${phoneToCall}`);

  /* on click Continue after select interest */
  document
    .querySelector('.summaryContinue__btn')
    .addEventListener('click', handleClickSumaryContinue);

  document.querySelector('.instant_quote_summary__container .switch-button-checkbox').onclick = () => {
    handleInstantQuoteSummary();
  };
}

async function handleClickSumaryContinue(e) {
  document.querySelector('.consultSummary__container')?.classList?.add('show-consult-summary');
  const btnRequestConsult = e.target;
  const loaderIcon = btnRequestConsult.querySelector('.loader__icon');
  btnRequestConsult.classList.add('disabled', 'hover');
  addColorButtonSwitch();
  if (loaderIcon) {
    loaderIcon.innerHTML = '';
    loaderIcon.style.display = 'flex';
    loaderIcon.insertAdjacentHTML('beforeend', `<img src="${appUrl
      }/assets/icons/rolling.png" />`);
  }

  navigateConsultSummary(() => {
    btnRequestConsult?.classList.remove('disabled');
    if(loaderIcon){
      loaderIcon.style.display = 'none';
    }
  });

}

 export function navigateConsultSummary(onNavigationComplete) {
  setTimeout(() => {
    if (providers.length > 0) {
      const provider = providers.find((i) => i.id === providerId);
      loadConsultDetail(provider, estimateInfo.line_items, estimateInfo.average_total);
    }

        document.getElementById('consult-summary')?.focus();

        if (onNavigationComplete) {
            onNavigationComplete();
        }
        handelConsultSummaryBtn();
    }, 400);
}

export function clearAllInput() {
  removeAllSelectedLocation();
  removeAllSelectProvider();
  removeAllProcedures();
  removeAllSelectedInterest();
  removeFullName();
  removeEmail();
  removePhone();
  document
    .querySelectorAll('.move-to-right')
    .forEach((i) => i.classList.remove('move-to-right'));

}


export function handleInstantQuoteSummary() {
  const switchButton = document.querySelector('.instant_quote_summary__container .switch-button-checkbox');
  if (estimateInfo.monthly_payment === null) {
    switchButton.checked = true;
  }
  if (estimateInfo.monthly_payment === null || estimateInfo.average_total === null) {
    switchButton.disabled = true;
  }
  addColorButtonSwitch();
  const totalResult = document.querySelector('.js-sum');
  if(hidePricing) {
    document.querySelector('.instant_quote_summary__container  .step__total').classList.add('hidden');
    document.querySelector('.instant_quote_summary__container  .step__breakdown').classList.add('hidden');
  }
  if (switchButton.checked) {
    if (totalResult && estimateInfo.average_total) {
      const averageTotalConvert = estimateInfo.average_total.toLocaleString('en-US');
      const finacingText = document.querySelector('.js-financing--text');
      finacingText.classList.add('hidden');
      totalResult.innerHTML = `<span class="average_total">$${averageTotalConvert}</span>`;
    }
  } else if (estimateInfo.monthly_payment) {
    const finacingText = document.querySelector('.js-financing--text');
    finacingText.classList.remove('hidden');
    const monthlyPaymentConvert = estimateInfo.monthly_payment.toLocaleString('en-US');
    totalResult.innerHTML = `$${monthlyPaymentConvert}<span class="total_month">${t('per_month')}</span>`;
  }
}

function addColorButtonSwitch() {
  const switchButtonCheckbox = document.querySelector('.instant_quote_summary__container .switch-button-checkbox');
  const switchButton = document.querySelector('.instant_quote_summary__container .switch-button');
  if(!switchButton) return;
  if(switchButtonCheckbox?.checked) {
    switchButton.classList.remove('white-color-before');
    switchButton.classList.add('white-color-after');
  }else {
    switchButton.classList.remove('white-color-after');
    switchButton.classList.add('white-color-before');
  }
}